import { isDateFuture } from '../../../utils/dateFunctions';
import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import {
    getNowDateOrEarlierMessage,
    getNumMaxMessage,
    getReqMessage,
    getSelectMessage
} from '../../../utils/formValidation/errorMessageFunctions';

export const DUK_MAX_VALUE = 47;

export const validate = (newEntry, initialState, isGpParticipationConsent) => {
    let newErrors = {};

    if (newEntry.dukValue && newEntry.dukValue > DUK_MAX_VALUE) {
        newErrors = {
            ...newErrors,
            dukValue: {
                error: true,
                message: getNumMaxMessage('Value', DUK_MAX_VALUE)
            }
        };
    }

    if (newEntry?.referralReturnedIncomplete && isDateFuture(newEntry.referralReturnedIncomplete)) {
        newErrors = {
            ...newErrors,
            referralReturnedIncomplete: {
                error: true,
                message: getNowDateOrEarlierMessage()
            }
        };
    }

    if (newEntry?.completeReferralsReceipt && isDateFuture(newEntry.completeReferralsReceipt)) {
        newErrors = {
            ...newErrors,
            completeReferralsReceipt: {
                error: true,
                message: getNowDateOrEarlierMessage()
            }
        };
    }

    if (isGpParticipationConsent && !newEntry.gpParticipationConsentId) {
        newErrors = {
            ...newErrors,
            gpParticipationConsentId: {
                error: true,
                message: getSelectMessage('value')
            }
        };
    }

    if (newEntry?.dateOfferedAltPathway) {
        if (isDateFuture(newEntry.dateOfferedAltPathway)) {
            newErrors = {
                ...newErrors,
                dateOfferedAltPathway: {
                    error: true,
                    message: getNowDateOrEarlierMessage()
                }
            };
        }
        if (typeof newEntry.acceptedAltPathway !== 'boolean') {
            newErrors = {
                ...newErrors,
                acceptedAltPathway: {
                    error: true,
                    message: getReqMessage('An option')
                }
            };
        }
    }

    if (Object.keys(newErrors).length < 1) newErrors = checkDiff(newEntry, initialState);

    return newErrors;
};
